import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IResetCommunityEngagementAction } from '../types';

const resetCommunityEngagement: IResetCommunityEngagementAction = action(() => ({
  ...initStore,
}));

export default resetCommunityEngagement;
